<template>
  <div class="account-settings-info-right">
    <div class="account-settings-info-title">
      <span>{{ $route.meta.title }}</span>
    </div>
    <!-- form -->
    <a-form-model
      ref="ruleForm"
      :rules="rules"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="用户名" prop="username">
        <a-input v-model="form.username" class="vd-input-s" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="昵称" prop="nickname">
        <a-input v-model="form.nickname" class="vd-input-s" />
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="form.email" class="vd-input-s" />
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="mobile">
        <a-input v-model="form.mobile" class="vd-input-s" />
      </a-form-model-item>
      <a-form-model-item label="性别" prop="gender">
        <a-select
          style="width: 104px"
          v-model="form.gender"
          placeholder="请选择你的性别"
        >
          <a-select-option :value="0"> 保密</a-select-option>
          <a-select-option :value="1"> 女</a-select-option>
          <a-select-option :value="2"> 男</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <!--  button  -->
    <a-button type="primary" style="margin-right: 8px" @click="update">
      保存
    </a-button>

    <!--    <a-button>-->
    <!--      重置-->
    <!--    </a-button>-->
  </div>
</template>

<script>
import { modify_info, refreshUserInfo } from '@/api'

export default {
  name: 'Base',
  data() {
    return {
      form: {
        username: '',
        nickname: '',
        email: '',
        mobile: '',
        gender: '',
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        nickname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '格式错误', trigger: 'blur' },
        ],
        gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
      },
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    this.form.username = this.userInfo.username
    this.form.email = this.userInfo.email
    this.form.mobile = this.userInfo.mobile
    this.form.gender = this.userInfo.gender
    this.form.nickname = this.userInfo.nickname
  },
  methods: {
    update() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify_info(this.form).then((res) => {
            if (res['code'] === 1) {
              this.$message.success(res['msg'])
              // 更新缓存中 user_info 的信息
              refreshUserInfo().then((res) => {
                if (res['code'] === 1) {
                  console.log(res['user_info'])
                  localStorage.setItem('ACCESS_TOKEN', res['token'])
                  localStorage.setItem(
                    'USER_INFO',
                    JSON.stringify(res['user_info'])
                  )
                  this.$router.go(0)
                } else {
                  this.$message.warning(res['msg'])
                }
              })
            } else {
              this.$message.warning(res['msg'])
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style></style>
